module.exports = __webpack_public_path__ + "static/media/ic_message_black.38c1d8e0.svg";